import axios from "axios";

export const http_uploadservice = axios.create({
  baseURL: process.env.VUE_APP_API_ICONS,
  headers: {
    "Authorization": "Bearer " + process.env.VUE_APP_API_ICONS_TOKEN
  }
});

export function store(data) {
  return http_uploadservice.post("upload", data, { headers: { "Accept": "multipart/form-data" } });
}

export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  const ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}
